import React from 'react';
import Modal from "../../../src/component/modal/ModalTemplate";

class ChargePressModal extends React.Component {
    constructor(props){
        super(props);
        this.state={}
    }// end constructor
    render() {
        const { isOpen, isClose } = this.props;
        return (
            <Modal className={"react-modal"} open={isOpen} handleClose={isClose} overlayClassName="modal-overlay">
                <div className='modal-body'>
                    보유 금액이 부족합니다. <br/>
                    보유 금액 충전 후 메시지 발송이 가능합니다 <br/>
                </div>
                <div className='modal-footer'>
                    <button className='btn btn-primary btn-md' onClick={() => window.location.href = "/cash/charge"}>충전하기</button>
                </div>
            </Modal>
        )
    }
}// end class

export default ChargePressModal;
